import React from 'react';
import CandidatoCard from './CandidatoCard';
import { Candidate } from './types/Candidate';

interface StageColumnProps {
  title: string;
  count: number;
  candidates: Candidate[];
}

const Columnas: React.FC<StageColumnProps> = ({ title, count, candidates }) => {
  return (
    <div className="bg-gray-100 rounded-lg p-4 w-1/3">
      <h3 className="text-lg font-bold mb-2">
        {title} ({count})
      </h3>
      <div className="space-y-2">
        {candidates.map((candidate, index) => (
          <CandidatoCard key={index} candidate={candidate} />
        ))}
      </div>
      <button className="mt-4 text-blue-600">Descartados ({candidates.filter(c => c.discarded).length})</button>
    </div>
  );
};

export default Columnas;
